export default () => (
  <div className="container full-height">
    <div style={{ textAlign: 'center' }}>
      <p>Terms condition</p>
    </div>
  </div>
);
